import React, { useEffect } from 'react';
import Button from '../../../components/button/Button';
import title from '../../../assets/webp-images/challenge-ob-consistency-title.png';
import '../../signup-form/user-experience-components/CustomerExperiencePage.css';
import { Mixpanel } from '../../../analytics/Mixpanel';

type Props = {
	onContinue: () => void;
};

const BezierCurve: React.FC = () => {
	const startPointX = 0; // Starting point X-coordinate
	const startPointY = 15; // Starting point Y-coordinate
	const controlPoint1X = 150; // Control point 1 X-coordinate
	const controlPoint1Y = 10; // Control point 1 Y-coordinate
	const controlPoint2X = 120; // Control point 2 X-coordinate
	const controlPoint2Y = 90; // Control point 2 Y-coordinate
	const endPointX = 280; // Ending point X-coordinate
	const endPointY = 90; // Ending point Y-coordinate

	const startPointX_2 = 0; // Starting point X-coordinate
	const startPointY_2 = 15; // Starting point Y-coordinate
	const controlPoint1X_2 = 50; // Control point 1 X-coordinate
	const controlPoint1Y_2 = 10; // Control point 1 Y-coordinate
	const controlPoint2X_2 = -20; // Control point 2 X-coordinate
	const controlPoint2Y_2 = 130; // Control point 2 Y-coordinate
	const endPointX_2 = 280; // Ending point X-coordinate
	const endPointY_2 = 150; // Ending point Y-coordinate

	return (
		<svg width='304' height='200'>
			<path
				className='drawn-line'
				d={`
          M ${startPointX_2} ${startPointY_2} 
          C ${controlPoint1X_2} ${controlPoint1Y_2}, 
            ${controlPoint2X_2} ${controlPoint2Y_2}, 
            ${endPointX_2} ${endPointY_2}
        `}
				fill='none'
				stroke='#B8ACF6'
				strokeWidth='4'
			/>
			<circle
				cx={endPointX_2 + 10}
				cy={endPointY_2}
				r={10}
				fill='none'
				stroke='#B8ACF6'
			/>
			<text
				x={endPointX_2 - 10}
				y={endPointY_2 + 20}
				fill='#B8ACF6'
				fontFamily={'Gordita-Medium'}
				fontSize={'12px'}
				fontWeight={'500'}
				textAnchor='middle'>
				Others
			</text>

			<path
				className='drawn-line'
				d={`
          M ${startPointX} ${startPointY} 
          C ${controlPoint1X} ${controlPoint1Y}, 
            ${controlPoint2X} ${controlPoint2Y}, 
            ${endPointX} ${endPointY}
        `}
				fill='none'
				stroke='blue'
				strokeWidth='4'
			/>
			<circle
				cx={endPointX + 10}
				cy={endPointY}
				r={10}
				fill='none'
				stroke='blue'
			/>
			<text
				x={endPointX - 4}
				y={endPointY + 20}
				fill='#4462EF'
				fontFamily={'Gordita-Medium'}
				fontSize={'12px'}
				fontWeight={'500'}
				textAnchor='middle'>
				Seek
			</text>
		</svg>
	);
};

const ChallengeObConsistency: React.FC<Props> = ({ onContinue }) => {
	const onContinueTap = () => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: 'Built for consistency',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: 'challenge',
		});
		onContinue();
	};

	useEffect(() => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'viewed',
			page_heading: 'Built for consistency',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: 'challenge',
		});
	}, []);

	return (
		<div>
			<img src={title} style={{ width: '100%', marginTop: '16px' }} alt='' />

			<div
				className={'customer-experience-body-container'}
				style={{ width: '100%', marginTop: '16px' }}>
				<div className={'customer-experience-animation-container'}>
					<p className={'customer-experience-body-animation-title'}>
						Attendance
					</p>
					<div className={'customer-experience-body-animation'}>
						<BezierCurve />
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'space-between',
								width: '100%',
							}}>
							<p className={'customer-experience-body-week'}>Day 1</p>
							<p className={'customer-experience-body-week'}>Day 21</p>
						</div>
					</div>
				</div>
				<p
					style={{ marginTop: '16px' }}
					className={'customer-experience-body-animation-subtitle'}>
					Seek users are{' '}
					<span style={{ fontFamily: 'Gordita-Medium' }}>3x</span> more
					consistent than average meditators
				</p>
			</div>
			<Button
				isSticky={true}
				style={{
					alignSelf: 'center',
					marginBottom: '24px',
					width: 'calc(100% - 56px)',
					background:
						'var(--Primary_Gradient, linear-gradient(106deg, #4462EF 32.65%, #1B3DD8 105.18%))',
				}}
				onClick={onContinueTap}
				label={'Continue'}></Button>
		</div>
	);
};

export default ChallengeObConsistency;
